import Player from '@vimeo/player';

// This code loads the IFrame Player API code asynchronously. This is the Youtube-recommended script loading method
let tag = document.createElement("script");
tag.src = "https://youtube.com/iframe_api";
tag.id = "youtubeScript";
let firstScriptTag = document.getElementsByTagName("script")[1];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const homepageHero = document.getElementById('hero-slider-wrapper');
const slides = homepageHero.getElementsByClassName('slide-video');

// we need to make global function available here in this script
// this is needed because of how webpack handle functions
window.addEventListener('load', function() {
    for (let i=0; i < slides.length; i++) {
        const element = slides[i].querySelector('.hero-slider__video');

        if ( element ) {
            const player_type = element.getAttribute('data-video-type');
            const player_id = element.getAttribute('data-video-id');

            if ( player_type == 'youtube' ) {
                onYouTubeIframeAPIReady(element, player_id);
            }

            if ( player_type == 'vimeo' ) {
                activateVimeoVideos(element, player_id);
            }

            if ( player_type == 'local' ) {
                initHtml5Videos(element);
            }
        }
    }
});

/**
 * Handle Vimeo videos creation
 */
function activateVimeoVideos(element, player_id) {
    const id = player_id,
          player_parent = element.parentNode;

    const player = new Player( element,
        {
            id,
            width: '100%',
            background: false,
            controls: false,
            loop: true,
            muted: true,
            autoplay: true,
            playsinline: true
        }
    );

    // Show play button if video is paused
    player.getPaused().then(function(paused) {
        player_parent.classList.add('show-button');
        
        if (paused) {
            player.play();
            player_parent.classList.remove('show-button');
        }
    });

    // Allow playback by clicking hero if video is paused at load
    player_parent.addEventListener('click', function () {
        player.play();
        this.classList.remove('show-button');
    });
}

/**
 * Handle YouTube videos creation
 */
function onYouTubeIframeAPIReady(element, player_id) {
    const player = new YT.Player(element, {
        height:'100%',
        width: '100%',
        fitToBackground: true,
        videoId: player_id,
        playerVars: {
            autoplay: 1,
            playsinline: 1,
            playlist: player_id,
            loop: 1,
            controls: 0,
            rel: 0,
            fs: 0,
            iv_load_policy: 3,
            enablejsapi: 1,
            origin: window.location.hostname
        },
        events: {
            'onReady': function( event ) {
                player.g.parentNode.classList.add('show-button');

                player.mute();
                player.setVolume(0);
                player.setLoop(true);
                
                // Show play button if video is paused
                if (event.data !== YT.PlayerState.PLAYING || event.data !== YT.PlayerState.BUFFERING) { // neither playing nor buffering
                    player.playVideo();
                    player.g.parentNode.classList.remove('show-button');
                }

                // Allow playback by clicking hero if video is paused at load
                player.g.parentNode.addEventListener('click', function () {
                    player.playVideo();
                });
            },
            'onStateChange' : function( event ) {
                // Hide play button if video is playing
                if (event.data == YT.PlayerState.PLAYING) {
                    player.g.parentNode.classList.remove('show-button');
                }
            }
        }
    });
}

/**
 * Handle locally-hosted videos creation
 */
function initHtml5Videos(element) {
    const player = element,
          player_parent = player.parentNode;

    // Show play button if video is paused
    if (player.paused) {
        player_parent.classList.add('show-button');
    }

    // Automatically play video when HTML document loaded
    document.body.addEventListener('DOMContentLoaded', function () {
        player.play();
    });

    // Hide play button if video is playing
    player.addEventListener('playing', function () {
        player_parent.classList.remove('show-button');
    });

    // Allow playback by clicking hero if video is paused at load
    player_parent.addEventListener('click', function () {
        player.play();
    });
}